!(function () {
  var a = {
    intlLocale: 'ar',
    date: { intlOptions: {} },
    time: {},
    currency: {},
    number: {},
  };
  (a.date.postFormatting = function (a, b, c) {
    var d = a.split('.')[0];
    return (
      (c = c
        .replace(/\u200F0/g, '‏')
        .replace(',', '،')
        .replace('الإثنين', 'الاثنين')),
      (c =
        'mdy.short' === a
          ? c
              .replace(/\u200F/g, '')
              .replace(/^0/, '')
              .replace(/\/0/, '/')
              .replace(/\//g, '‏/')
          : c.replace(/\u200F|\u200E/g, '').replace(' 0', ' ')),
      'time.short' === a
        ? (c = c.replace(/\//g, '‏/'))
        : 'my' === d && (c = c.replace('،', '')),
      'd' !== d && 'm' !== d && 'y' !== d
        ? 0 !== c.indexOf('‏') && (c = '‏' + c)
        : (c = c.replace(/^\u200F/, '')),
      c
    );
  }),
    (a.date.narrowDayNames = ['حد', 'اث', 'ثل', 'أر', 'خم', 'جم', 'سب']);
  var b = a.date.intlOptions;
  (b.time = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  }),
    (b['time.long'] = b.time),
    (b['time.medium'] = b.time),
    (b['time.short'] = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }),
    (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
    (b['mdy.long'] = b.mdy),
    (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
    (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
    (b.my = { year: 'numeric', month: 'long' }),
    (b['my.long'] = b.my),
    (b['my.medium'] = { year: 'numeric', month: 'short' }),
    (b['my.short'] = b['my.medium']),
    (b.md = { month: 'long', day: 'numeric' }),
    (b['md.long'] = b.md),
    (b['md.medium'] = { month: 'short', day: 'numeric' }),
    (b['md.short'] = b['md.medium']),
    (b.m = { month: 'long' }),
    (b['m.long'] = b.m),
    (b['m.medium'] = { month: 'short' }),
    (b['m.short'] = { month: 'numeric' }),
    (b.d = { weekday: 'long' }),
    (b['d.long'] = b.d),
    (b['d.medium'] = { weekday: 'short' }),
    (b['d.short'] = { day: 'numeric' }),
    (b.y = { year: 'numeric' }),
    (b['y.long'] = b.y),
    (b['y.medium'] = b.y),
    (b['y.short'] = { year: 'numeric' }),
    (a.time.postFormatting = function (a, b, c) {
      return (c = c.replace(/^0/, ''));
    }),
    (a.currency.postFormatting = function (a, b, c) {
      return (
        (c = c.replace(/\s/g, ' ')),
        0 > b &&
          (0 !== c.indexOf('‎') && (c = '‎' + c),
          (c = c.replace(/[\u002D\u2212]/g, '').replace(' ', ' -'))),
        'CNY' === a && (c = c.replace(/CNY|\uFFE5/, 'CN¥')),
        c
      );
    }),
    (a.number.postFormatting = function (a, b) {
      return 0 > a && (b = '-' + b.replace('-', '')), b.replace('‎', '');
    });
  var c = t8.Chooser.CATEGORIES;
  (a.chooser = {
    equals: {
      0: c.ZERO,
      1: c.SINGULAR,
      2: c.DUAL,
      3: c.FEW,
      4: c.FEW,
      5: c.FEW,
      6: c.FEW,
      7: c.FEW,
      8: c.FEW,
      9: c.FEW,
      10: c.FEW,
    },
    endsWith: {
      '00': c.PLURAL,
      '01': c.PLURAL,
      '02': c.PLURAL,
      '03': c.FEW,
      '04': c.FEW,
      '05': c.FEW,
      '06': c.FEW,
      '07': c.FEW,
      '08': c.FEW,
      '09': c.FEW,
      10: c.FEW,
      0: c.MANY,
      1: c.MANY,
      2: c.MANY,
      3: c.MANY,
      4: c.MANY,
      5: c.MANY,
      6: c.MANY,
      7: c.MANY,
      8: c.MANY,
      9: c.MANY,
    },
  }),
    t8.__addLocaleData('ar_AE', a);
})(),
  (function () {
    var a = {
      intlLocale: 'cs',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    (a.date.postFormatting = function (a, b, c) {
      var d = a.split('.')[0];
      return (
        ('d.short' === a || 'm.medium' === a || 'm.short' === a) &&
          ((c += '.'), (c = c.replace('..', '.'))),
        (c = c
          .replace(/\./g, '. ')
          .replace(/\u0020\u0020/g, ' ')
          .replace(/(\u0020)+$/g, '')),
        'md' === d
          ? ((c = c.replace(/\./g, '').split(' ')),
            (c = c[0].replace(/^0/, '') + '. ' + c[1]),
            'md.long' !== a && (c += '.'))
          : ('my.medium' === a || 'my.short' === a) &&
            (c = c.replace(' ', '/')),
        c
      );
    }),
      (a.date.narrowDayNames = ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So']);
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'numeric' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'numeric', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'numeric' }),
      (b['m.short'] = b['m.medium']),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: 'numeric' }),
      (a.currency.postFormatting = function (a, b, c) {
        return 'CNY' === a && (c = c.replace(/CNY|\uFFE5/, 'CN¥')), c;
      }),
      (a.number = { maximumFractionDigits: 2 });
    var c = t8.Chooser.CATEGORIES;
    (a.chooser = {
      equals: { 0: c.PLURAL, 1: c.SINGULAR, 2: c.DUAL, 3: c.DUAL, 4: c.DUAL },
      endsWith: {
        0: c.PLURAL,
        1: c.PLURAL,
        2: c.PLURAL,
        3: c.PLURAL,
        4: c.PLURAL,
        5: c.PLURAL,
        6: c.PLURAL,
        7: c.PLURAL,
        8: c.PLURAL,
        9: c.PLURAL,
      },
    }),
      t8.__addLocaleData('cs_CZ', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'da',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      return (
        'my.medium' === a || 'my.short' === a || 'mdy.medium' === a
          ? (c = c.replace(/\./g, '').replace(/\s/g, '. '))
          : /^(m|md)\.medium|^(d|md)\.short/.test(a) && !/\.$/.test(c)
          ? (c += '.')
          : 'd.medium' === a &&
            ((c = c
              .replace(/s\u00F8$/, 'søn.')
              .replace(/ma$/, 'man.')
              .replace(/ti$/, 'tir.')
              .replace(/on$/, 'ons.')
              .replace(/to$/, 'tor.')
              .replace(/fr$/, 'fre.')
              .replace(/l\u00F8$/, 'lør.')),
            /\.$/.test(c) || (c += '.')),
        (c = c
          .replace('maj.', 'maj')
          .replace(/-/g, '/')
          .replace(':', '.')
          .replace(/^0/, '')
          .replace(/\/0/, '/'))
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: 'numeric' }),
      (a.time.postFormatting = function (a, b, c) {
        return /^\d\./.test(c) && (c = '0' + c), c.replace(/:/g, '.');
      }),
      (a.currency.postFormatting = function (a, b, c) {
        return 'CNY' === a && (c = c.replace(/CNY|\uFFE5/, 'CN¥')), c;
      }),
      (a.possessive = {
        fallback: 's',
        rules: {
          '.*[SsXxZz]$': '’',
          '.*[A-RT-WYÅÆØ]$': 'S',
          '.*[a-rt-wyåæø]$': 's',
        },
      }),
      t8.__addLocaleData('da_DK', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'de',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    (a.date.postFormatting = function (a, b, c) {
      var d = a.split('.')[0];
      return (
        'md' !== d || /\.\s/.test(c)
          ? ('mdy.medium' === a || 'my.medium' === a || 'my.short' === a) &&
            (c = c.replace(/\./g, '').replace(/\s/g, '. '))
          : (c = c.replace(/\s/g, '. ')),
        /^(d|m|md)\.medium|^md\.short/.test(a) && !/\.$/.test(c) && (c += '.'),
        (c = c
          .replace(/^0/, '')
          .replace(/\.0/g, '.')
          .replace(/Mrz\.|M\u00E4r(z)?\./g, 'März')
          .replace(/Mai\./, 'Mai')
          .replace(/Jun(i)?\./, 'Juni')
          .replace(/Jul(i)?\./, 'Juli')
          .replace(',', ''))
      );
    }),
      (a.date.narrowDayNames = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']);
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: 'numeric' }),
      (a.time.postFormatting = function (a, b, c) {
        return /^\d:/.test(c) && (c = '0' + c), c;
      }),
      (a.currency.postFormatting = function (a, b, c) {
        return 'CNY' === a && (c = c.replace(/CNY|\uFFE5/, 'CN¥')), c;
      }),
      (a.possessive = {
        fallback: 's',
        rules: {
          '.*[SsXxZzß]$': '’',
          '.*[A-RT-WYÄÖÜ]$': 'S',
          '.*[a-rt-wyäöü]$': 's',
        },
      }),
      t8.__addLocaleData('de_DE', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'en',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      var d = a.split('.')[0];
      return (
        (c = c.replace(/\s0/, ' ')),
        'my' === d
          ? (c = c.replace(/,/g, ''))
          : 'time' === d &&
            ((c = c.split(' ')),
            5 !== c.length || /,$/.test(c[2])
              ? 3 !== c.length || /,$/.test(c[0]) || (c[0] = c[0] + ',')
              : (c[2] = c[2] + ','),
            (c = c.join(' '))),
        c
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: '2-digit' }),
      (a.currency.getCurrencyDisplay = function (a) {
        return /^(DKK|NOK|SGD|ZAR|SEK|CHF)$/.test(a) ? 'code' : 'symbol';
      }),
      (a.currency.postFormatting = function (a, b, c) {
        var d = /^(\(|-)?\$/,
          e = { AUD: 'A$', CAD: 'CA$', HKD: 'HK$', NZD: 'NZ$' };
        return (
          'undefined' != typeof e[a]
            ? (c = c.replace(d, e[a]))
            : 'INR' === a && (c = c.replace(/Rs\./, '₹')),
          0 > b && c.indexOf(')') >= 0 && (c = '-' + c.replace(/[\(\)]/g, '')),
          c.replace(/\s/, '')
        );
      }),
      (a.possessive = {
        fallback: '’s',
        rules: { '.*[Ss]$': '’', '.*[A-RT-Z]$': '’S', '.*[a-rt-z]$': '’s' },
      }),
      t8.__addLocaleData('en_US', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'es',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      var d = a.split('.')[0];
      return (
        /^(d|m|my)$/.test(d)
          ? (c = c.toLocaleLowerCase())
          : 'md' !== d || /\sde\s/.test(c)
          ? 'mdy.medium' !== a ||
            /\sde\s/.test(c) ||
            ((c = c.split(' ')),
            c.splice(1, 0, 'de'),
            c.splice(3, 0, 'de'),
            (c = c.join(' ')))
          : (c = c.replace(/\s/, ' de ')),
        ('my.medium' !== a && 'my.short' !== a) ||
          /\.\sde/.test(c) ||
          (c = c.replace(/\.\s/, '. de ')),
        /((d|m|md)\.medium)|md\.short/.test(a) && !/\.$/.test(c) && (c += '.'),
        'y.short' !== a && (c = c.replace(/^0/, '').replace(/\/0/g, '/')),
        c.replace('sep.', 'sept.')
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: '2-digit' }),
      (a.currency.getCurrencyDisplay = function (a) {
        return 'EUR' === a ? 'symbol' : 'code';
      }),
      (a.currency.postFormatting = function (a, b, c) {
        return c.replace(/\s/g, '.').replace(/\.(?=[^\.]*$)/, ' ');
      }),
      (a.number.postFormatting = function (a, b) {
        return b.replace(/\s/g, '.');
      }),
      t8.__addLocaleData('es_ES', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'fr',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      var d = a.split('.')[0];
      return (
        ('m' === d || 'my' === d) && (c = c.toLocaleLowerCase()),
        (c = c.replace(/^0/, '').replace(/\/0/, '/'))
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: 'numeric' }),
      (a.time.postFormatting = function (a, b, c) {
        return /^\d:/.test(c) && (c = '0' + c), c;
      });
    var c = t8.Chooser.CATEGORIES;
    (a.chooser = {
      equals: { 0: c.SINGULAR, 1: c.SINGULAR },
      endsWith: {
        0: c.PLURAL,
        1: c.PLURAL,
        2: c.PLURAL,
        3: c.PLURAL,
        4: c.PLURAL,
        5: c.PLURAL,
        6: c.PLURAL,
        7: c.PLURAL,
        8: c.PLURAL,
        9: c.PLURAL,
      },
    }),
      t8.__addLocaleData('fr_FR', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'id',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      var d = a.split('.')[0];
      return (
        'time' === d
          ? (c = c.replace(/\./g, ':'))
          : 'd.medium' === a &&
            (c = c
              .replace('Minggu', 'Min')
              .replace('Rabu', 'Rab')
              .replace('Kamis', 'Kam')
              .replace('Jumat', 'Jum')
              .replace('Sabtu', 'Sab')),
        /((m|my|md|mdy)\.medium)|((md|my)\.short)/.test(a) &&
          (c = c.replace('Agust', 'Agt')),
        'time.short' !== a && 'mdy.short' !== a && (c = c.replace(/^0/, '')),
        c.replace('Nop', 'Nov')
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: '2-digit', day: '2-digit' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: 'numeric' }),
      (a.time.postFormatting = function (a, b, c) {
        return (c = c.replace(/:/g, '.')), /^\d\./.test(c) && (c = '0' + c), c;
      }),
      (a.currency.postFormatting = function (a, b, c) {
        return (
          0 > b && c.indexOf(')') >= 0 && (c = '-' + c.replace(/[()]/g, '')),
          'CNY' === a && (c = c.replace(/CNY|\uFFE5/, 'CN¥')),
          c.replace(/\s/, '')
        );
      }),
      t8.__addLocaleData('in_ID', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'it',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      var d = a.split('.')[0];
      return (
        'time' === d
          ? (c = c.replace(/,/g, ''))
          : /^(d|m|my)$/.test(d)
          ? (c = c.toLocaleLowerCase())
          : 'mdy.medium' === a && (c = c.replace(/\//g, ' ')),
        /mdy\.medium|md\.(long|medium|short)/.test(a) &&
          (c = c.replace(/^0/, '')),
        c
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: '2-digit', day: '2-digit' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: '2-digit' }),
      (a.time.postFormatting = function (a, b, c) {
        return /^\d:/.test(c) && (c = '0' + c), c;
      }),
      (a.currency.postFormatting = function (a, b, c) {
        return 'CNY' === a && (c = c.replace(/CNY|\uFFE5/, 'CN¥')), c;
      }),
      t8.__addLocaleData('it_IT', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'ja',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      return (
        /^m\.(short|medium)/.test(a) && !/\u6708/.test(c)
          ? (c += '月')
          : /^(mdy|time)\.short/.test(a) &&
            (c = c.replace(/(\u5E74|\u6708)/g, '/').replace(/\u65E5/, '')),
        c.replace('月月', '月')
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'narrow' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: 'numeric' }),
      (a.currency.getCurrencyDisplay = function (a) {
        return /^(INR|DKK|NOK|SGD|ZAR|SEK|CHF)$/.test(a) ? 'code' : 'symbol';
      }),
      (a.currency.postFormatting = function (a, b, c) {
        var d = /^(-)?\$/,
          e = { AUD: 'AU$', CAD: 'CA$', HKD: 'HK$', NZD: 'NZ$' };
        return (
          'undefined' != typeof e[a] && d.test(c) && (c = c.replace(d, e[a])),
          0 > b && !/^-/.test(c) && (c = '-' + c.replace(/(-|(|))/g, '')),
          c.replace(/\s/g, '').replace(/\u00A5/g, '￥')
        );
      }),
      t8.__addLocaleData('ja_JP', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'ko',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      return (
        /^m\.(short|medium)/.test(a) && !/\uC6D4/.test(c)
          ? (c += '월')
          : /^(mdy|time)\.short/.test(a) &&
            (c = c.replace(/(\uB144|\uC6D4|\uC77C)/g, '.')),
        c.replace('월월', '월')
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: 'numeric' }),
      (a.currency.getCurrencyDisplay = function (a) {
        return /^(DKK|NOK|SGD|ZAR|SEK|CHF)$/.test(a) ? 'code' : 'symbol';
      }),
      (a.currency.postFormatting = function (a, b, c) {
        var d = /^(\(|-)?\$/,
          e = { AUD: 'AU$', CAD: 'CA$', HKD: 'HK$', NZD: 'NZ$', USD: 'US$' };
        return (
          'undefined' != typeof e[a]
            ? (c = c.replace(d, e[a]))
            : 'INR' === a && (c = c.replace(/Rs\./, '₹')),
          'JPY' !== a ||
            /JP\u00A5/.test(c) ||
            (c = c.replace(/\u00A5/g, 'JP¥')),
          0 > b && !/^-/.test(c) && (c = '-' + c.replace(/[-\(\)]/g, '')),
          c.replace(/\s/, '')
        );
      }),
      t8.__addLocaleData('ko_KR', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'ms',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      return (
        c.indexOf('Ogos') < 0 && (c = c.replace(/Ogo/, 'Ogos')),
        'd.medium' === a
          ? (c = c
              .replace(/Ahad/, 'Ahd')
              .replace('Isnin', 'Isn')
              .replace('Rabu', 'Rab')
              .replace('Khamis', 'Kha')
              .replace('Jumaat', 'Jum')
              .replace('Sabtu', 'Sab'))
          : /^(m|md|my|mdy)\.(medium|short)/.test(a)
          ? (c = c.replace('Sept', 'Sep'))
          : /^time\./.test(a) &&
            (/\s\.$/.test(c)
              ? (c = c.replace(/\.$/, 'PTG'))
              : /\s$/.test(c) && (c += 'PG')),
        c.replace(/^0/, '').replace(/\/0/, '/')
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: !0,
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: !0,
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: 'numeric' }),
      (a.time.intlOptions = {
        hm: { hour: 'numeric', minute: 'numeric', hour12: !0 },
        hms: {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: !0,
        },
      }),
      (a.time.postFormatting = function (a, b, c) {
        return (
          /\s\.$/.test(c)
            ? (c = c.replace(/\.$/, 'PTG'))
            : /\s$/.test(c) && (c += 'PG'),
          (c = c.replace('PTG', 'PM').replace('PG', 'AM'))
        );
      }),
      (a.currency.postFormatting = function (a, b, c) {
        return (
          0 > b && !/^-/.test(c) && (c = '-' + c.replace(/[-\(\)]/g, '')),
          'CNY' === a && (c = c.replace(/CNY|\uFFE5/, 'CN¥')),
          c.replace(/\s/, '')
        );
      }),
      t8.__addLocaleData('ms_MY', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'nl',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      var d = a.split('.')[0];
      return (
        /^(m|d|my)$/.test(d) && (c = c.toLocaleLowerCase()),
        'm.medium' === a
          ? (c = c.replace('.', ''))
          : /^md\.(medium|short)/.test(a) && !/\.$/.test(c)
          ? (c += '.')
          : /^my\.(medium|short)/.test(a) && !/\./.test(c)
          ? (c = c.replace(/\s/, '. '))
          : 'mdy.medium' !== a ||
            /[1-9]\s[a-z]+/.test(c) ||
            (c = c.replace(/\./g, '. ').replace(/\./, '')),
        c.replace(/^0/, '').replace(/mei\./, 'mei')
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: 'numeric' }),
      (a.time.postFormatting = function (a, b, c) {
        return /^\d:/.test(c) && (c = '0' + c), c;
      }),
      (a.currency.postFormatting = function (a, b, c) {
        return (
          0 !== c.indexOf(a) &&
            (c = a + ' ' + c.replace(a, '').replace(/\s$/, '')),
          0 > b && (c = c.replace(/[\u002D\u2212]/g, '').replace(' ', ' -')),
          'CNY' === a && (c = c.replace(/CNY|\uFFE5/, 'CN¥')),
          c
        );
      }),
      t8.__addLocaleData('nl_NL', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'nb',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      return (
        (c = c
          .replace(/^s\u00F8(\.)?$/, 'søn')
          .replace(/^ma(\.)?$/, 'man')
          .replace(/^ti(\.)?$/, 'tir')
          .replace(/^on(\.)?$/, 'ons')
          .replace(/^to(\.)?$/, 'tor')
          .replace(/^fr(\.)?$/, 'fre')
          .replace(/^l\u00F8(\.)?$/, 'lør')
          .replace(/:/, '.')),
        /^(d|md|m)\.short|^(d|md)\.medium/.test(a) && !/\.$/.test(c)
          ? (c += '.')
          : 'mdy.medium' !== a || /\s/.test(c)
          ? /my\.(medium|short)/.test(a) && !/\.\s/.test(c)
            ? (c = c.replace(/\s/, '. '))
            : /^time\./.test(a) &&
              !/,/.test(c) &&
              ((c = c.split(' ')),
              c.length >= 2 && (c[c.length - 2] += ','),
              (c = c.join(' ')))
          : (c = c.replace(/\./g, '. ')),
        'y.short' !== a &&
          ((c = c.replace(/^0/, '')),
          /\.0[1-9]\./.test(c) && (c = c.replace(/\.0/, '.'))),
        c.replace('mai.', 'mai')
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: '2-digit' }),
      (a.time.postFormatting = function (a, b, c) {
        return (c = c.replace(/:/g, '.')), /^\d\./.test(c) && (c = '0' + c), c;
      }),
      (a.currency.postFormatting = function (a, b, c) {
        return (
          0 > b &&
            !/^\u2212/.test(c) &&
            (c = '−' + c.replace(/\u002D|-|\(|\)/g, '')),
          c
        );
      }),
      (a.number.postFormatting = function (a, b) {
        return 0 > a && (b = b.replace('−', '-')), b;
      }),
      (a.possessive = {
        fallback: 's',
        rules: { '.*[SsXxZz]$': '’', '.*[A-RT-WY]$': 'S', '.*[a-rt-wy]$': 's' },
      }),
      t8.__addLocaleData('no_NO', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'pl',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      if (
        ('d.medium' === a
          ? (c = c
              .replace(/^P(n|t)$/, 'P')
              .replace(/^Wt$/, 'W')
              .replace(/^\u015Ar$/, 'Ś')
              .replace(/^Cz$/, 'C')
              .replace(/^So$/, 'S'))
          : 'mdy.short' === a && /[0-9]{4}\-[0-9]{2}\-[0-9]{2}/.test(c)
          ? ((c = c.split('-')), (c = c[2] + '.' + c[1] + '.' + c[0]))
          : /^time\./.test(a) &&
            !/,/.test(c) &&
            ((c = c.split(' ')),
            c.length >= 2 && (c[c.length - 2] += ','),
            (c = c.join(' '))),
        'time.short' === a && /[0-9]{2}\-[0-9]{2}\-[0-9]{2},\s[0-9:]+$/.test(c))
      ) {
        var d = c.split(',');
        (c = d[0].split('-')),
          (c = c[2] + '.' + c[1] + '.' + c[0] + ',' + d[1]);
      }
      return c.replace(/^0/, '');
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'narrow' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: 'numeric' }),
      (a.time.postFormatting = function (a, b, c) {
        return /^\d:/.test(c) && (c = '0' + c), c;
      });
    var c = t8.Chooser.CATEGORIES;
    (a.chooser = {
      equals: {
        0: c.PLURAL,
        1: c.SINGULAR,
        12: c.PLURAL,
        13: c.PLURAL,
        14: c.PLURAL,
      },
      endsWith: {
        0: c.PLURAL,
        1: c.PLURAL,
        2: c.DUAL,
        3: c.DUAL,
        4: c.DUAL,
        5: c.PLURAL,
        6: c.PLURAL,
        7: c.PLURAL,
        8: c.PLURAL,
        9: c.PLURAL,
      },
    }),
      t8.__addLocaleData('pl_PL', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'pt',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      return (
        /^(mdy|m)\.medium|^md\./.test(a) &&
          (c = c.replace(/^0/, '').replace(/\./g, ' de ')),
        c
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: '2-digit' }),
      (a.time.postFormatting = function (a, b, c) {
        return /^\d:/.test(c) && (c = '0' + c), c;
      }),
      (a.currency.postFormatting = function (a, b, c) {
        return (
          0 > b && !/^-/.test(c) && (c = '-' + c.replace(/-/, '')),
          'CNY' === a && (c = c.replace(/CNY|\uFFE5/, 'CN¥')),
          c.replace(/\s/, '')
        );
      }),
      t8.__addLocaleData('pt_BR', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'ro',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      var d = a.split('.')[0];
      return (
        /(^(m|my|(d(\.long)?$)))/.test(a)
          ? (c = c.toLocaleLowerCase())
          : 'd.medium' === a
          ? (c = c
              .replace(/^D$/, 'Dum')
              .replace(/^L$/, 'Lun')
              .replace(/^Ma$/, 'Mar')
              .replace(/^Mi$/, 'Mie')
              .replace(/^J$/, 'Joi')
              .replace(/^V$/, 'Vin')
              .replace(/^S$/, 'Sâm'))
          : 'time' !== d ||
            /,/.test(c) ||
            ((c = c.split(' ')),
            4 === c.length
              ? (c[2] = c[2] + ',')
              : 2 === c.length && (c[0] = c[0] + ','),
            (c = c.join(' '))),
        c
          .replace(/mar\u0163i/, 'marți')
          .replace(/sep\./, 'sept.')
          .replace(/mai\./, 'mai')
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: 'numeric' }),
      (a.time.postFormatting = function (a, b, c) {
        return /^\d:/.test(c) && (c = '0' + c), c;
      });
    var c = t8.Chooser.CATEGORIES;
    (a.chooser = {
      equals: {
        0: c.DUAL,
        1: c.SINGULAR,
        2: c.DUAL,
        3: c.DUAL,
        4: c.DUAL,
        5: c.DUAL,
        6: c.DUAL,
        7: c.DUAL,
        8: c.DUAL,
        9: c.DUAL,
        10: c.DUAL,
        11: c.DUAL,
        12: c.DUAL,
        13: c.DUAL,
        14: c.DUAL,
        15: c.DUAL,
        16: c.DUAL,
        17: c.DUAL,
        18: c.DUAL,
        19: c.DUAL,
      },
      endsWith: {
        0: c.PLURAL,
        1: c.PLURAL,
        2: c.PLURAL,
        3: c.PLURAL,
        4: c.PLURAL,
        5: c.PLURAL,
        6: c.PLURAL,
        7: c.PLURAL,
        8: c.PLURAL,
        9: c.PLURAL,
      },
    }),
      t8.__addLocaleData('ro_RO', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'ru',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    (a.date.postFormatting = function (a, b, c) {
      var d,
        e = a.split('.')[0],
        f = {
          янв: 'янв.',
          фев: 'февр.',
          мар: 'март',
          апр: 'апр.',
          июн: 'июнь',
          июл: 'июль',
          авг: 'авг.',
          сен: 'сент.',
          окт: 'окт.',
          ноя: 'нояб.',
          дек: 'дек.',
        },
        g = { март: 'марта', май: 'мая', июнь: 'июня', июль: 'июля' };
      'm' === e || 'd' === e || 'my' === e
        ? (c = c.toLocaleLowerCase())
        : 'y' === e
        ? (c = c.replace(/\s\u0433\.$/, ''))
        : 'md' !== e || /^[0-9]+/.test(c)
        ? 'time.short' !== a || /,/.test(c)
          ? /time\.(long|medium)/.test(a) &&
            !/,/.test(c) &&
            (c = c.replace('г.', 'г.,'))
          : (c = c.replace(' ', ', '))
        : ((c = c.split(' ')),
          (c =
            2 === c.length
              ? c[1].replace(/^0/, '') + ' ' + c[0]
              : c.join(' ')));
      for (d in f)
        if (new RegExp(d + '( |$)').test(c)) {
          c = c.replace(new RegExp(d), f[d]);
          break;
        }
      if (/^(md|mdy)\./.test(a))
        for (d in g)
          if (new RegExp(d + '( |$)').test(c)) {
            c = c.replace(new RegExp(d), g[d]);
            break;
          }
      return c;
    }),
      (a.date.narrowDayNames = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб']);
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: '2-digit' }),
      (a.currency.postFormatting = function (a, b, c) {
        return 'CNY' === a && (c = c.replace(/CNY|\uFFE5/, 'CN¥')), c;
      });
    var c = t8.Chooser.CATEGORIES;
    (a.chooser = {
      endsWith: {
        0: c.PLURAL,
        1: c.SINGULAR,
        2: c.DUAL,
        3: c.DUAL,
        4: c.DUAL,
        5: c.PLURAL,
        6: c.PLURAL,
        7: c.PLURAL,
        8: c.PLURAL,
        9: c.PLURAL,
        11: c.PLURAL,
        12: c.PLURAL,
        13: c.PLURAL,
        14: c.PLURAL,
      },
    }),
      t8.__addLocaleData('ru_RU', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'sv',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      var d = a.split('.')[0],
        e = a.split('.')[1];
      if (
        (/^(d|m|my|md|mdy)/.test(a) &&
          (c = c.replace('.', '').toLocaleLowerCase()),
        'd.medium' === a)
      ) {
        var f = {
          sö: 'sön',
          må: 'mån',
          ti: 'tis',
          on: 'ons',
          to: 'tors',
          tor: 'tors',
          fr: 'fre',
          lö: 'lör',
        };
        for (var g in f)
          if (c === g) {
            c = f[g];
            break;
          }
      }
      return (
        ('short' !== e && 'medium' !== e) ||
          'time' === d ||
          (c = c
            .replace('juni', 'jun')
            .replace('juli', 'jul')
            .replace('mars', 'mar')),
        (c = c.replace('den ', '')),
        'md.long' === a && c.indexOf(':e') >= 0 && (c = c.replace(':e', '')),
        c
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: 'numeric' }),
      (a.time.postFormatting = function (a, b, c) {
        return /^\d:/.test(c) && (c = '0' + c), c;
      }),
      (a.currency.postFormatting = function (a, b, c) {
        return (
          0 > b && (c = c.replace('-', '−')),
          (c = c.replace(':', ',')),
          c.replace(/\./g, ' ')
        );
      }),
      (a.number.postFormatting = function (a, b) {
        return 0 > a && (b = b.replace('−', '-')), b;
      }),
      (a.possessive = {
        fallback: 's',
        rules: {
          '.*[SsXxZz]$': '',
          '.*[A-RT-WYÅÄÖ]$': 'S',
          '.*[a-rt-wyåäö]$': 's',
        },
      }),
      t8.__addLocaleData('sv_SE', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'th',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      var d = a.split('.')[0];
      if ('y' === d) (c = c.split(' ')), (c = c.length > 1 ? c[1] : c[0]);
      else if ('d' === d) {
        var e = {
          อาทิตย์: 'วันอาทิตย์',
          จันทร์: 'วันจันทร์',
          อังคาร: 'วันอังคาร',
          พุธ: 'วันพุธ',
          พฤหัสบดี: 'วันพฤหัสบดี',
          ศุกร์: 'วันศุกร์',
          เสาร์: 'วันเสาร์',
        };
        for (var f in e)
          if (c === f) {
            c = e[f];
            break;
          }
      }
      return c.replace(/^0/, '');
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: 'numeric' }),
      (a.time.postFormatting = function (a, b, c) {
        return /^\d:/.test(c) && (c = '0' + c), c;
      }),
      (a.currency.getCurrencyDisplay = function (a) {
        return /^(DKK|NOK|SGD|ZAR|SEK|CHF)$/.test(a) ? 'code' : 'symbol';
      }),
      (a.currency.postFormatting = function (a, b, c) {
        var d = /^(\(|-)?\$/,
          e = { AUD: 'AU$', CAD: 'CA$', HKD: 'HK$', NZD: 'NZ$', USD: 'US$' };
        return (
          'undefined' != typeof e[a]
            ? (c = c.replace(d, e[a]))
            : 'INR' === a && (c = c.replace(/Rs\./, '₹')),
          0 > b &&
            0 !== c.indexOf('-') &&
            (c = '-' + c.replace(/[\u002D\(\)]/g, '')),
          c.replace(/\s/, '')
        );
      }),
      t8.__addLocaleData('th_TH', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'fil',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      var d = a.split('.')[0];
      if ('d' === d) {
        var e = {
          Mierkoles: 'Miyerkules',
          Huebes: 'Huwebes',
          Biernes: 'Biyernes',
          Mier: 'Miy',
          Hueb: 'Huw',
          Bier: 'Biy',
          Saba: 'Sab',
        };
        for (var f in e)
          if (c === f) {
            c = e[f];
            break;
          }
      } else
        'my' === d
          ? (c = c.replace(/,/, ''))
          : 'time' === d &&
            ((c = c.split(' ')),
            5 !== c.length || /,$/.test(c[2])
              ? 3 !== c.length || /,$/.test(c[0]) || (c[0] = c[0] + ',')
              : (c[2] = c[2] + ','),
            (c = c.join(' ')));
      if (/^(m|md|my|mdy)\.(medium|short)/.test(a)) {
        var g = { Mayo: 'May', Agos: 'Ago', En: 'Ene', Sept: 'Set' };
        for (var h in g)
          if (new RegExp(h + '( |$)').test(c)) {
            c = c.replace(h, g[h]);
            break;
          }
      }
      return (
        'y' !== d && (c = c.replace(/^0/, '').replace(/\s0/, ' ')),
        c.replace('Septyembre', 'Setyembre')
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: '2-digit' }),
      (a.currency.postFormatting = function (a, b, c) {
        return (
          0 > b &&
            0 !== c.indexOf('-') &&
            (c = '-' + c.replace(/[\u002D\(\)]/g, '')),
          'CNY' === a && (c = c.replace(/CNY|\uFFE5/, 'CN¥')),
          c.replace(/\s/, '')
        );
      }),
      t8.__addLocaleData('tl_PH', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'tr',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      return (
        (c = c.replace('  ', ' ')),
        /^(mdy|time)\.long|(time|md)\.medium|md\.short/.test(a) &&
          (c = c.replace(/^0/, '')),
        'time.short' === a &&
          c.indexOf('.') < 0 &&
          ((c = c.split(' ')),
          (c = c[0] + '.' + c[1] + '.' + c[2] + ' ' + c[3])),
        c
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: 'numeric',
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: 'numeric',
      }),
      (b.mdy = { year: 'numeric', month: 'long', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'long' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'long', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = { month: 'long' }),
      (b['m.long'] = b.m),
      (b['m.medium'] = { month: 'short' }),
      (b['m.short'] = { month: 'numeric' }),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: '2-digit' }),
      (a.time.postFormatting = function (a, b, c) {
        return /^\d:/.test(c) && (c = '0' + c), c;
      }),
      (a.currency.postFormatting = function (a, b, c) {
        return 'CNY' === a && (c = c.replace(/CNY|\uFFE5/, 'CN¥')), c;
      }),
      t8.__addLocaleData('tr_TR', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'zh',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      var d = ['月', '日', '年'],
        e = a.split('.')[0],
        f = a.split('.')[1],
        g = /(^\s+|\s+$)/g;
      if ('d' !== e || 'short' === f)
        for (var h = 0; h < d.length; h++)
          c = c.replace(d[h], ' ' + d[h] + ' ');
      return (
        'm' === e
          ? (c = c.split('月')[0] + '月')
          : ('time.short' === a || 'mdy.short' === a) &&
            (c = c
              .replace(/\s(\u6708|\u5E74)\s/g, '/')
              .replace(/\s\u65E5\s/g, '')),
        c
          .replace('  ', ' ')
          .replace('月 月', '月 ')
          .replace(g, '')
          .replace(/\u5348\s/, '午')
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'narrow',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: !0,
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: !0,
      }),
      (b.mdy = { year: 'numeric', month: 'narrow', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'narrow' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'narrow', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = b['md.short']),
      (b['m.long'] = b.m),
      (b['m.medium'] = b.m),
      (b['m.short'] = b.m),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'short' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: 'numeric' }),
      (a.time.intlOptions = {
        hm: { hour: 'numeric', minute: 'numeric', hour12: !0 },
        hms: {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: !0,
        },
      }),
      (a.time.postFormatting = function (a, b, c) {
        return (
          c.indexOf('午 ') < 0 && (c = c.replace('午', '午 ')),
          c.indexOf('12:') >= 0 &&
            (c = c.replace('上午', '午夜').replace('下午', '中午')),
          c
        );
      }),
      (a.currency.getCurrencyDisplay = function (a) {
        return /^(DKK|NOK|SGD|ZAR|SEK|CHF)$/.test(a) ? 'code' : 'symbol';
      }),
      (a.currency.postFormatting = function (a, b, c) {
        var d = /[0-9]/,
          e = /^(\(|-)?\$/,
          f = { AUD: 'AU$', CAD: 'CA$', HKD: 'HK$', NZD: 'NZ$', USD: 'US$' };
        'undefined' != typeof f[a]
          ? (c = c.replace(e, f[a] + ' '))
          : 'JPY' !== a || /JP\u00A5/.test(c)
          ? 'EUR' !== a || /\u20AC\u00A0/.test(c)
            ? 'INR' === a
              ? ((c = c.replace(/Rs\./, '₹')),
                /\u20B9\u00A0/.test(c) || (c = c.replace(/\u20B9/, '₹ ')))
              : 'GBP' !== a || /\u00A3\u00A0/.test(c)
              ? /\$\u00A0/.test(c) || (c = c.replace(/\$/, '$ '))
              : (c = c.replace(/\u00A3/, '£ '))
            : (c = c.replace(/\u20AC/, '€ '))
          : (c = c.replace(/\u00A5/, 'JP¥ '));
        var g = c.search(d);
        return (
          g > 0 &&
            (/\s/.test(c.charAt(g - 1)) ||
              (c = c.slice(0, g) + ' ' + c.slice(g))),
          0 > b && c.indexOf(')') >= 0 && (c = '-' + c.replace(/[\(\)]/g, '')),
          c
        );
      }),
      t8.__addLocaleData('zh_CN', a);
  })(),
  (function () {
    var a = {
      intlLocale: 'zh',
      date: { intlOptions: {} },
      time: {},
      currency: {},
      number: {},
    };
    a.date.postFormatting = function (a, b, c) {
      var d = ['月', '日', '年'],
        e = a.split('.')[0],
        f = a.split('.')[1],
        g = /(^\s+|\s+$)/g;
      if ('d' !== e || 'short' === f)
        for (var h = 0; h < d.length; h++)
          c = c.replace(d[h], ' ' + d[h] + ' ');
      return (
        'd.medium' === a && -1 === c.indexOf('周') && (c = '周' + c),
        'm' === e
          ? (c = c.split('月')[0] + '月')
          : ('time.short' === a || 'mdy.short' === a) &&
            (c = c
              .replace(/\s(\u6708|\u5E74)\s/g, '/')
              .replace(/\s\u65E5\s/g, '')),
        c
          .replace('  ', ' ')
          .replace('月 月', '月 ')
          .replace(g, '')
          .replace(/\u5348\s/, '午')
      );
    };
    var b = a.date.intlOptions;
    (b.time = {
      year: 'numeric',
      month: 'narrow',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: !0,
    }),
      (b['time.long'] = b.time),
      (b['time.medium'] = b.time),
      (b['time.short'] = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: !0,
      }),
      (b.mdy = { year: 'numeric', month: 'narrow', day: 'numeric' }),
      (b['mdy.long'] = b.mdy),
      (b['mdy.medium'] = { year: 'numeric', month: 'short', day: 'numeric' }),
      (b['mdy.short'] = { year: 'numeric', month: 'numeric', day: 'numeric' }),
      (b.my = { year: 'numeric', month: 'narrow' }),
      (b['my.long'] = b.my),
      (b['my.medium'] = { year: 'numeric', month: 'short' }),
      (b['my.short'] = b['my.medium']),
      (b.md = { month: 'narrow', day: 'numeric' }),
      (b['md.long'] = b.md),
      (b['md.medium'] = { month: 'short', day: 'numeric' }),
      (b['md.short'] = b['md.medium']),
      (b.m = b['md.short']),
      (b['m.long'] = b.m),
      (b['m.medium'] = b.m),
      (b['m.short'] = b.m),
      (b.d = { weekday: 'long' }),
      (b['d.long'] = b.d),
      (b['d.medium'] = { weekday: 'narrow' }),
      (b['d.short'] = { day: 'numeric' }),
      (b['d.narrow'] = { weekday: 'narrow' }),
      (b.y = { year: 'numeric' }),
      (b['y.long'] = b.y),
      (b['y.medium'] = b.y),
      (b['y.short'] = { year: 'numeric' }),
      (a.time.intlOptions = {
        hm: { hour: 'numeric', minute: 'numeric', hour12: !0 },
        hms: {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: !0,
        },
      }),
      (a.time.postFormatting = function (a, b, c) {
        return (
          c.indexOf('午 ') < 0 && (c = c.replace('午', '午 ')),
          c.indexOf('12:') >= 0 &&
            (c = c.replace('上午', '午夜').replace('下午', '中午')),
          c
        );
      }),
      (a.currency.getCurrencyDisplay = function (a) {
        return /^(DKK|NOK|SGD|ZAR|SEK|CHF)$/.test(a) ? 'code' : 'symbol';
      }),
      (a.currency.postFormatting = function (a, b, c) {
        var d = /[0-9]/,
          e = /^(\(|-)?\$/,
          f = { AUD: 'AU$', CAD: 'CA$', HKD: 'HK$', NZD: 'NZ$', USD: 'US$' };
        'undefined' != typeof f[a]
          ? (c = c.replace(e, f[a] + ' '))
          : 'CNY' === a
          ? (c = c.replace(/CNY|\uFFE5/, 'CN¥'))
          : 'JPY' !== a || /JP\u00A5/.test(c)
          ? 'EUR' !== a || /\u20AC\u00A0/.test(c)
            ? 'INR' === a
              ? ((c = c.replace(/Rs\./, '₹')),
                /\u20B9\u00A0/.test(c) || (c = c.replace(/\u20B9/, '₹ ')))
              : 'GBP' !== a || /\u00A3\u00A0/.test(c)
              ? /\$\u00A0/.test(c) || (c = c.replace(/\$/, '$ '))
              : (c = c.replace(/\u00A3/, '£ '))
            : (c = c.replace(/\u20AC/, '€ '))
          : (c = c.replace(/\u00A5/, 'JP¥ '));
        var g = c.search(d);
        return (
          g > 0 &&
            (/\s/.test(c.charAt(g - 1)) ||
              (c = c.slice(0, g) + ' ' + c.slice(g))),
          0 > b && c.indexOf(')') >= 0 && (c = '-' + c.replace(/[\(\)]/g, '')),
          c
        );
      }),
      t8.__addLocaleData('zh_TW', a);
  })();
